enum roles {
    HR = "hr",
    ADMIN = "Admin"
}

export default roles